/* eslint-disable max-len */
import React from 'react'
import { string } from 'prop-types'

function Architectural(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3857 1.60541C10.6957 1.45059 11.0647 1.46721 11.3594 1.64935C11.6538 1.83163 11.833 2.1536 11.833 2.49994V5.29779L16.3877 8.3349C16.6657 8.52039 16.833 8.83272 16.833 9.16693V16.4999H17.5C18.0521 16.5002 18.5 16.9478 18.5 17.4999C18.5 18.052 18.0521 18.4997 17.5 18.4999H2.5C1.94774 18.4999 1.50004 18.0522 1.5 17.4999C1.5 16.9477 1.94772 16.4999 2.5 16.4999H3.16699V5.83294C3.16711 5.4543 3.38104 5.10776 3.71973 4.93841L10.3857 1.60541ZM5.16699 6.45111V16.4999H9.83301V4.1181L5.16699 6.45111ZM11.833 16.4999H14.833V9.70111L11.833 7.70111V16.4999ZM7.5 13.9999C8.05208 14.0002 8.5 14.4478 8.5 14.9999V15.0087C8.49972 15.5606 8.0519 16.0085 7.5 16.0087C6.94789 16.0087 6.50028 15.5608 6.5 15.0087V14.9999C6.5 14.4477 6.94772 13.9999 7.5 13.9999ZM7.5 11.4999C8.05208 11.5002 8.5 11.9478 8.5 12.4999V12.5087C8.49972 13.0606 8.0519 13.5085 7.5 13.5087C6.94789 13.5087 6.50028 13.0608 6.5 12.5087V12.4999C6.5 11.9477 6.94772 11.4999 7.5 11.4999ZM7.5 8.99994C8.05208 9.00018 8.5 9.4478 8.5 9.99994V10.0087C8.49972 10.5606 8.0519 11.0085 7.5 11.0087C6.94789 11.0087 6.50028 10.5608 6.5 10.0087V9.99994C6.5 9.44765 6.94772 8.99994 7.5 8.99994ZM7.5 6.49994C8.05208 6.50018 8.5 6.9478 8.5 7.49994V7.50873C8.49972 8.06062 8.0519 8.50848 7.5 8.50873C6.94789 8.50873 6.50028 8.06077 6.5 7.50873V7.49994C6.5 6.94765 6.94772 6.49994 7.5 6.49994Z"
        fill="#35424F"
      />
    </svg>
  )
}

Architectural.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Architectural
